
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basic-elements/formulare",
      function () {
        return require("private-next-pages/basic-elements/formulare.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basic-elements/formulare"])
      });
    }
  